module.exports = __webpack_public_path__ + "static/media/404.786cffd3.svg";